import DTextField from "components/common/DTextField";
import GridContainer from "components/common/GridContainer";
import GridItem from "components/common/GridItem";
import resource from "pages/EmployeeWorkspace/Resources/characterReferenceResource";
/*import RHFSelect from "components/forms/RHFSelect";*/

export default function TabForm({ register, errors, control }) {
    return (
        <GridContainer spacing={2}>
            <GridItem xs={12} md={4}>
                <DTextField
                    name={resource.fields.lastName.name}
                    label={resource.fields.lastName.label}
                    required={resource.fields.lastName.required}
                    error={!!errors.lastName}
                    {...register(resource.fields.lastName.name)}
                />
            </GridItem>
            <GridItem xs={12} md={4}>
                <DTextField
                    name={resource.fields.firstName.name}
                    label={resource.fields.firstName.label}
                    required={resource.fields.firstName.required}
                    error={!!errors.firstName}
                    {...register(resource.fields.firstName.name)}
                />
            </GridItem>
            <GridItem xs={12} md={4}>
                <DTextField
                    name={resource.fields.middleName.name}
                    label={resource.fields.middleName.label}
                    required={resource.fields.middleName.required}
                    error={!!errors.middleName}
                    {...register(resource.fields.middleName.name)}
                />
            </GridItem>
            <GridItem xs={12} md={8}>
                <DTextField
                    name={resource.fields.adress1.name}
                    label={resource.fields.adress1.label}
                    required={resource.fields.adress1.required}
                    options={resource.fields.adress1.options ?? []}
                    multiline
                    error={!!errors.adress1}
                    {...register(resource.fields.adress1.name)}
                />
            </GridItem>
            <GridItem xs={12} md={4}>
                <DTextField
                    name={resource.fields.phoneNumber.name}
                    label={resource.fields.phoneNumber.label}
                    required={resource.fields.phoneNumber.required}
                    options={resource.fields.phoneNumber.options ?? []}
                    multiline
                    error={!!errors.phoneNumber}
                    {...register(resource.fields.phoneNumber.name)}
                />
            </GridItem>
        </GridContainer>
    );
}
